import classnames from 'classnames';
import React from 'react';

const CSS = require('./ModalHeader.module.scss');

interface ModalHeaderProps {
  children: any;
  hasBorder?: boolean;
  className?: string;
}

function ModalHeader({
  children,
  hasBorder,
  className,
  ...rest
}: ModalHeaderProps) {
  return (
    <div
      className={classnames(CSS.ModalHeader, {
        [className]: className,
        [CSS.ModalHeaderBorder]: hasBorder,
      })}
      {...rest}
    >
      {children}
    </div>
  );
}

export default ModalHeader;
